






























































































































import { dataTableItemsPerPage, MODULE_COLORS } from "@/utility/Constants";
import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import _ from "lodash";

//Components
import EventConfigurationDialog from "./EventConfigurationDialog.vue";

//Model
import { GetConfigurationHistoryEventsCommand } from "@/model/communication/security/GetConfigurationHistoryEventsCommand";
import { GetConfigurationHistoryEventsResData } from "@/model/communication/security/GetConfigurationHistoryEventsResData";
import { GetSecurityEventConfigurationCommand } from "@/model/communication/security/GetSecurityEventConfigurationCommand";
import { GetSecurityEventConfigurationResData } from "@/model/communication/security/GetSecurityEventConfigurationResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";

export default Vue.extend({
    components: { EventConfigurationDialog },
    data() {
        return {
            MODULE_COLORS,
            moment,
            eventsLoading: false,
            eventsHistory: [],
            search: "",
            dataTableItemsPerPage,
            headers: [
                {
                    text: "",
                    value: "eventIcon",
                    sortable: false,
                },
                {
                    text: this.$t("common.event"),
                    value: "eventType",
                    sortable: false,
                },
                {
                    text: this.$t("common.eventTimestamp"),
                    value: "dateTime",
                },
                {
                    text: this.$t("caosTemplate.templateName"),
                    value: "name",
                },
                {
                    text: this.$t("common.installations"),
                    value: "installations",
                    width: "40%",
                    sortable: false,
                },
                {
                    text: this.$t("reference_configuration.configuration"),
                    value: "configuration",
                    align: "center",
                    sortable: false,
                    width: "150px",
                },
            ],
            options: {},
            totalEvents: 0,
            dateRange: [],
            selectedEvent: null,
            showInfoDialog: false,
            configLoading: false,
            rollsProfile: null,
            templateContent: TemplateContentEnum.None,
        };
    },
    computed: {
        ...mapGetters(["longDateFormat", "userDateFormat"]),

        sortedDateRangeFormatted() {
            let formatted = [];
            if (this.sortedDateRange != null && this.sortedDateRange != undefined) this.sortedDateRange.forEach((dt) => formatted.push(moment(dt).format(this.userDateFormat)));
            return formatted;
        },
        sortedDateRange() {
            return _(this.dateRange).sort();
        },
    },
    methods: {
        async sendRequest() {
            try {
                this.eventsLoading = true;
                let dates = [];
                this.sortedDateRange.forEach((el) => dates.push(moment.utc(el).toDate()));
                let response: GetConfigurationHistoryEventsResData = await new GetConfigurationHistoryEventsCommand(dates[0], dates[1]).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.configurationsHistory) {
                    this.totalEvents = response.configurationsHistory.length;
                    this.eventsHistory = response.configurationsHistory;
                }
            } catch (e) {
                console.log("Something went wrong sending GetConfigurationHistoryEvents request ", e);
            }
            this.eventsLoading = false;
        },
        async sendConfigRequest(event) {
            try {
                this.configLoading = true;
                let response: GetSecurityEventConfigurationResData = await new GetSecurityEventConfigurationCommand(event.id).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.selectedEvent = event;
                    this.selectedEvent.configuration = response.eventConfiguration;
                    this.rollsProfile = response.rollsProfile;
                    if (event.name) {
                        this.templateContent = TemplateContentEnum.None;
                        if (this.selectedEvent.configuration && this.selectedEvent.configuration.alarms && this.selectedEvent.configuration.alarms.length)
                            this.templateContent |= TemplateContentEnum.Alarms;
                        if (this.selectedEvent.configuration && this.selectedEvent.configuration.delays && this.selectedEvent.configuration.delays.length)
                            this.templateContent |= TemplateContentEnum.Delays;
                        if (this.selectedEvent.configuration && this.selectedEvent.configuration.timeBands && this.selectedEvent.configuration.timeBands.length)
                            this.templateContent |= TemplateContentEnum.TimeBands;
                        if (this.selectedEvent.configuration && this.selectedEvent.configuration.rollsConfig && this.selectedEvent.configuration.rollsConfig.length)
                            this.templateContent |= TemplateContentEnum.Rollconfig;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending GetSecurityEventConfiguration request ", e);
            }
            this.configLoading = false;
        },
        openInfoDialog(item) {
            this.showInfoDialog = true;
            this.sendConfigRequest(item);
        },
        filterByDate(event) {
            this.backToTheFirst();
            this.sendRequest(event);
        },
        backToTheFirst() {
            if (this.options.page != 1) this.options.page = 1;
        },
    },
    created() {
        let endDate = new Date();
        let startDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
        startDate.setDate(startDate.getDate() - 30);
        this.dateRange.push(moment(startDate).utc().format());
        this.dateRange.push(moment(endDate).utc().format());
        this.sendRequest();
    },
});
